module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.removeBtnName !== 'Remove Payment' && _vm.removeBtnName !== 'Remove Single Invoice',
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.handleRemovePayment
    }
  }, [_vm._v("\n    " + _vm._s(_vm.removeBtnName) + "\n    "), (_vm.removeBtnName !== 'Remove Payment' && _vm.removeBtnName !== 'Remove Single Invoice') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e330d56","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/RemoveSlineInvoiceButton.vue
// module id = 2613
// module chunks = 0